// @flow
import type { FullState } from '../../../types';
import type { SearchState } from '../../types';

const selectRaw = (state: FullState): SearchState =>
  state.domainTransfer.search;
const selectSearchValue = (state: FullState): string => selectRaw(state).input;
const selectSearchLoading = (state: FullState): boolean =>
  selectRaw(state).spinner;

export { selectSearchValue, selectSearchLoading };
